var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram_icon_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-1208.000000, -1506.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram_icon_white",
    transform: "translate(1208.000000, 1506.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,11.3082707 C16,12.6917293 15.5169811,13.8947368 14.6716981,14.7368421 C13.8264151,15.5789474 12.6188679,16 11.290566,16 L4.70943396,16 C3.38113208,16 2.17358491,15.5789474 1.32830189,14.7368421 C0.422641509,13.8947368 0,12.6917293 0,11.3082707 L0,4.69172932 C0,1.92481203 1.87169811,0 4.70943396,0 L11.3509434,0 C12.7396226,0 13.8867925,0.481203008 14.7320755,1.32330827 C15.5773585,2.16541353 16,3.30827068 16,4.69172932 L16,11.3082707 L16,11.3082707 Z M11.0138249,2 L4.93087558,2 C4.04608295,2 3.2718894,2.2764977 2.77419355,2.77419355 C2.2764977,3.2718894 2,4.04608295 2,4.93087558 L2,11.0138249 C2,11.8986175 2.2764977,12.6728111 2.82949309,13.2258065 C3.38248848,13.7235023 4.10138249,14 4.98617512,14 L11.0138249,14 C11.8986175,14 12.6728111,13.7235023 13.1705069,13.2258065 C13.7235023,12.7281106 14,11.9539171 14,11.0691244 L14,4.98617512 C14,4.10138249 13.7235023,3.38248848 13.2258065,2.82949309 C12.6728111,2.2764977 11.9539171,2 11.0138249,2 L11.0138249,2 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5 C11.4375,5 11,4.5625 11,4 C11,3.4375 11.4375,3 12,3 C12.5625,3 13,3.4375 13,4 C13,4.5625 12.5625,5 12,5 Z M7.97080292,12 C5.75182482,12 4,10.1764706 4,8 C4,5.76470588 5.81021898,4 7.97080292,4 C10.1313869,4 12,5.76470588 12,8 C12,10.2352941 10.189781,12 7.97080292,12 Z M8,10 C9.1045695,10 10,9.1045695 10,8 C10,6.8954305 9.1045695,6 8,6 C6.8954305,6 6,6.8954305 6,8 C6,9.1045695 6.8954305,10 8,10 Z",
    id: "shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconWhite);
export default __webpack_public_path__ + "static/media/instagram_icon_white.52470b77972cf23d9edff3c2db334a6b.svg";
export { ForwardRef as ReactComponent };